<template>
  <div class="mt-14 mx-auto">
    <h3 class="text-xxl text-center font-bold grid">
      {{ trans.title }}
    </h3>
    <button
						dusk="integrated-button-popup"
      class="integrated-button"
      :class="{ 'grid-cols-2': !this.pallars_school && !isMobile }"
      @click="togglePopup"
    >
      <div
        class="flex items-center"
        :class="[this.pallars_school ? 'mx-auto' : 'mr-auto']"
      >
        <img src="/img/icons/map-localize.svg" />
        <span class="text-[13px]" v-html="buttonText"></span>
      </div>
      <div
        v-if="!this.pallars_school && !isMobile"
        class="flex items-center ml-auto"
      >
        <img src="/img/icons/navigation.svg" />
        <p class="text-red font-medium">{{ trans.ubication }}</p>
      </div>
    </button>
    <button
      v-if="!this.pallars_school && isMobile"
      class="flex items-center mx-auto mb-8 w-fit"
      @click="togglePopup"
    >
      <img src="/img/icons/navigation.svg" />
      <p class="text-red font-medium">{{ trans.ubication }}</p>
    </button>
    <hr />
  </div>
</template>

<script>
import { isMobile } from "../../screenUtils";
export default {
  props: ["pallars_school"],
  data() {
    return {
      trans: "",
      isMobile: isMobile(),
      school: JSON.parse(this.pallars_school || null),
    };
  },
  computed: {
    textWhenSchoolSelected(){
      return isMobile() ? '<span class="font-bold"> ' + this.school.title + '</span>' : this.trans.selected + '<span class="font-bold"> ' + this.school.title + '</span>'
    },
    buttonText() {
      return this.pallars_school ? this.textWhenSchoolSelected : this.trans.search
    },
  },
  methods: {
    togglePopup() {
      document.getElementById("app").classList.toggle("fixed");
      document.getElementsByTagName("footer")[0].classList.toggle("fixed");
      document.getElementById("modal-select-school").classList.toggle("hidden");
    },
  },
  mounted() {
    this.$root.$on("show-popup", () => {
      this.togglePopup();
    });
    this.trans = window?.trans;
  },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";
.integrated-button {
  border-radius: 6px;
  display: grid;
  background: white;
  width: 675px;
  height: 60px;
  padding: 18px 20px;
  margin: 40px auto 30px;
  align-items: center;
  justify-items: center;

  @media (max-width: $lg) {
    max-width: 375px;
    width: 100%;
  }
}

img {
  margin-right: 10px;
}

.bold {
  font-weight: bold;
}
</style>
